import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.split";
import _typeof from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fromItems from "./mixin/fromItems";
import { includess, torepeat } from "@/utils/index.js";
export default {
  mixins: [fromItems],
  name: "ykSelects",
  props: {
    value: {},
    notArray: false,
    arrayisnumber: false,
    data: Array,
    api: {
      default: undefined
    },
    listName: {
      type: String
    },
    code: {
      type: Number,
      default: 200
    },
    popper_class: "",
    popper_append_to_body: {
      type: Boolean,
      default: true
    },
    apiJson: {},
    filterable: {
      type: Boolean,
      default: true
    },
    collapsetags: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: true
    },
    multiple: Boolean,
    // 多选
    checkall_disabled: Boolean,
    // 多选情况下不可点击全选
    seachkey: {
      default: function _default() {
        return ["label"];
      }
    },
    datakey: {
      default: function _default() {
        return {
          label: "label",
          value: "value"
        };
      }
    },
    autopop: {
      default: true
    },
    emptycontent: {
      default: ""
    },
    childDataName: {},
    maxitem: {
      default: 10000
    },
    pushdata: {
      default: function _default() {
        return [];
      }
    },
    showcolumn: {
      default: function _default() {
        return [];
      }
    },
    disableddata: {
      default: function _default() {
        return {};
      }
    },
    defaultselect: {
      // selectall // 单选传值
    },
    nocache: {
      default: false
    },
    searchquery: {
      default: ""
    }
  },
  data: function data() {
    return {
      checkAll: false,
      mloading: false,
      currentValue: "",
      valueType: "",
      myData: [],
      seachTime: null,
      seachData: [],
      queryWord: "",
      lookvalue: ""
    };
  },
  mounted: function mounted() {
    if (this.api !== undefined) {
      this.getData();
    } else {
      this.loadData(this.data);
    }
    this.setCurrentValue(this.value);
  },
  computed: {
    isIndeterminate: function isIndeterminate() {
      if (this.multiple === true) {
        this.resetCheckAll();
        return this.currentValue !== undefined && this.currentValue.length > 0 && !this.isSelectAll();
      } else {
        return false;
      }
    },
    myalldata: function myalldata() {
      var serverData = this.api === undefined ? this.data : this.myData;
      if (this.mloading) {
        return [];
      }
      var t = this;
      var retData = [];
      if (this.queryWord === "") {
        // / 拉出选中项
        var haveindexd = -1;
        serverData.map(function (bitem, d) {
          if (bitem[t.datakey.value] === t.currentValue) {
            retData.push(bitem);
            haveindexd = d;
          }
        });
        if (this.maxitem !== 10000) {
          for (var a = 0; a < (serverData.length > this.maxitem ? this.maxitem : serverData.length); a++) {
            if (a !== haveindexd) {
              retData.push(serverData[a]);
            }
          }
          return retData;
        } else {
          return serverData;
        }
      }
      var parsedQuery = String(this.queryWord).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, "\\$1");
      var c = 0;
      var candoit = true;
      this.seachData.map(function (aitem, i) {
        if (candoit) {
          if (new RegExp(parsedQuery, "i").test(aitem.key.replace(/[_/+]/g, ""))) {
            // if (true) {
            c++;
            retData.push(serverData[i]);
            if (c >= t.maxitem) {
              candoit = false;
              return retData;
            }
          }
        }
      });
      return retData;
    }
  },
  methods: {
    checkdefaultselect: function checkdefaultselect() {
      if (this.multiple === true && this.defaultselect !== undefined) {
        if (this.defaultselect === "selectall") {
          this.checkAll = true;
          this.handleCheckAllChange(this.checkAll);
        }
      }
    },
    handleCheckAllChange: function handleCheckAllChange(data, ev) {
      console.log("selectall", this.$refs.checkbox.model, ev, this.checkAll);
      if (!this.$refs.checkbox.model === true) {
        var myuseData = this.api === undefined ? this.data : this.myData;
        var alldata = [];
        for (var i = 0; i < myuseData.length; i++) {
          if (this.queryWord !== "") {
            for (var j = 0; j < this.currentValue.length; j++) {
              if (!myuseData[i].disabled && this.currentValue[j] === myuseData[i].value) {
                alldata.push(myuseData[i][this.datakey.value]);
              }
            }
          } else {
            if (!myuseData[i].disabled) {
              alldata.push(myuseData[i][this.datakey.value]);
            }
          }
        }
        if (this.queryWord !== "") {
          var arralldata = this.myalldata.filter(function (value) {
            return !value.disabled;
          }).map(function (val) {
            return val.value;
          });
          if (includess(alldata, arralldata)) {
            for (var _i = 0; _i < this.myalldata.length; _i++) {
              for (var k = 0; k < alldata.length; k++) {
                if (alldata[k] === this.myalldata[_i].value) {
                  alldata.splice(k, 1);
                  k--;
                }
              }
            }
          } else {
            alldata = alldata.concat(arralldata);
          }
        }
        // 去重
        alldata = torepeat(alldata);
        this.change(alldata);
      } else {
        this.change([]);
      }
    },
    clickselectall: function clickselectall() {},
    filterMethod1: function filterMethod1(query) {
      clearTimeout(this.seachTime);
      var t = this;
      this.seachTime = setTimeout(function () {
        t.queryWord = query;
        // console.log(query, 'query');
        t.$emit("update:searchquery", query);
      }, 200);
    },
    myvisiblechange: function myvisiblechange(va) {
      if (this.queryWord !== "" && va) {
        this.queryWord = "";
      }
      if (!va) {
        this.change(this.currentValue, "myvisiblechange"); // 下拉框关闭触发
      }
    },
    setCurrentValue: function setCurrentValue(value) {
      var myvalue = value;
      if (this.multiple === true) {
        // 去源数据value类型
        if (myvalue instanceof Array) {
          this.valueType = _typeof(myvalue[myvalue.length - 1]);
        }
        // 当notArray true时，将传过来的逗号分隔字符串转为数组
        if (this.notArray && !(myvalue instanceof Array)) {
          // 如果字符串为空，并且是多选，则给value = []
          if (myvalue.length > 0) {
            myvalue = myvalue.split(",");
            // 如果类型是number，则将数组转为number
            if (this.valueType === "number" || this.arrayisnumber) {
              myvalue = myvalue.map(function (res) {
                return +res;
              });
            }
          } else {
            myvalue = [];
          }
        }
      }
      if (myvalue === this.currentValue) return;
      this.currentValue = myvalue;
      this.resetCheckAll();
    },
    resetCheckAll: function resetCheckAll() {
      this.checkAll = this.isSelectAll();
    },
    isSelectAll: function isSelectAll() {
      if (this.multiple === true) {
        var modellength = this.currentValue && this.currentValue.length || 0;
        if (modellength === (this.api === undefined ? this.data.length : this.myData.length)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    change: function change(val, fnName) {
      var value = val;
      var _fnName = fnName || null;
      this.$emit("input", this.notArray ? value.join() : value);
      var arrData = [];
      var allData = this.api === undefined ? this.data : this.myData;
      for (var i = 0; i < allData.length; i++) {
        if (!this.multiple) {
          if (allData[i][this.datakey.value] === val) {
            arrData.push(allData[i]);
          }
        } else {
          val == undefined ? val = [] : null;
          for (var j = 0; j < val.length; j++) {
            if (allData[i][this.datakey.value] === val[j]) {
              arrData.push(allData[i]);
            }
          }
        }
      }
      this.$emit("change", arrData);
      if (_fnName === "myvisiblechange") {
        this.$emit("myvisiblechange", arrData);
      }
      this.setCurrentValue(value);
    },
    clear: function clear() {
      this.$emit("clear", []);
    },
    loadData: function loadData(_data) {
      var _this = this;
      var t = this;
      setTimeout(function () {
        _this.seachData = [];
        var labelkey = t.datakey["label"];
        for (var i = 0; i < _data.length; i++) {
          var mykey = "";
          for (var a = 0; a < t.seachkey.length; a++) {
            var myseachkeys = t.seachkey[a] === "label" ? labelkey : t.seachkey[a];
            if (_data[i][myseachkeys] !== undefined) {
              mykey += _data[i][myseachkeys] + "||";
            }
          }
          t.seachData.push({
            key: mykey
          });
        }
        t.resetCheckAll();
      }, 1);
    },
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var result, isAllArray, myDataX, mybackdata, i;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.mloading = true;
              if (!(this.api !== undefined)) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.api(this.apiJson, {
                cache: this.nocache !== true,
                loading: false,
                autoPop: this.autopop
              });
            case 1:
              result = _context.v;
              if (result.code === this.code) {
                this.mloading = false;
                isAllArray = false;
                myDataX = [];
                mybackdata = this.childDataName === undefined ? result.data[this.listName] : result.data.data[this.childDataName];
                if (mybackdata.length > 0) {
                  if (typeof mybackdata[0] === "string" || typeof mybackdata[0] === "number") {
                    isAllArray = true;
                    for (i = 0; i < mybackdata.length; i++) {
                      myDataX.push({
                        label: mybackdata[i],
                        value: mybackdata[i]
                      });
                    }
                  }
                }
                if (isAllArray) {
                  this.myData = this.pushdata.concat(myDataX);
                  // this.myData = myDataX.concat(this.pushdata);
                } else {
                  this.myData = this.pushdata.concat(mybackdata); // mybackdata.concat()
                  // this.myData = mybackdata.concat(this.pushdata);// mybackdata.concat()
                }
                this.$emit("onsuccess", this.myData);
              }
              this.loadData(this.myData);
              this.checkdefaultselect();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
  },
  watch: {
    value: function value(newData, oldData) {
      // console.log(newData, oldData, 'ooooo');
      this.setCurrentValue(newData);
    },
    myData: function myData(newData, oldData) {
      // console.log(newData, oldData, 'ooooo2');
      this.$emit("update:data", newData);
    },
    data: function data(newData, oldData) {
      this.loadData(newData);
    },
    apiJson: function apiJson(newData, oldData) {
      // console.log(newData, oldData, 'ooooo4');
      if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
        this.getData();
      }
    }
  }
};